import React from 'react';

const LoadingIndicator = ({ activeTable }) => {
    return (
        <div className="flex justify-center items-center h-80 w-full">
            <div className="relative flex flex-col items-center">
                <div className="w-16 h-16 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
                <p className="mt-4 text-lg font-medium text-indigo-600">Loading {activeTable} data...</p>
            </div>
        </div>
    );
};

export default LoadingIndicator;